import { render } from "./TerminalPage.vue?vue&type=template&id=6a5a5e70"
import script from "./TerminalPage.vue?vue&type=script&lang=js"
export * from "./TerminalPage.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__